import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class RoleCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this.getRoles();
    }

    refresh = () => {
        this._ctrl.clear();
        this.getRoles();
    }

    getRoles = () => {
        this._isMounted = true;
        
        let rq = {
            userTypeCode: this.props.userTypeCode
        }

        API.Security.get('/query/getRoles', rq,
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.roleName, value: item.roleId } })
                });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c}} />
        )
    }
}

export default RoleCombo;

// Mark this as a form component
RoleCombo.defaultProps = {
    formControl: true,
    managed: false,
    userTypeCode: null
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/roleCombo/RoleCombo.js